const authLangs = {
  login: "Đăng nhập",
  loginSystem: "Đăng nhập vào hệ thống",
  newUser: "Thành viên mới?",
  contactAdmin: "Liên hệ admin",
};
export default authLangs;
